import Layout from '@/layout'
export default {
    meta: {
        title: '评分',
        icon: 'b-tj'
    },
    path: "/score",
    component: Layout,
    children: [
        {
            path: '/score/ServiceScore',
            name: 'ServiceScore',
            component: () => import('@/views/score/ServiceScore'),
            meta: {
                title: '服务评分',
                auth: [],
                img: "pf"
            },
            props: route => {
                return route.query;
            }
        },
        {
            path: '/score/ServiceScoreDtl',
            name: 'ServiceScoreDtl',
            component: () => import('@/views/score/ServiceScoreDtl'),
            meta: {
                title: '服务详情',
                auth: [],
                img: "azx"
            },
            props: route => {
                return route.query;
            }
        },
        {
            path: '/score/ServiceScoreDtlTis',
            name: 'ServiceScoreDtlTis',
            component: () => import('@/views/score/ServiceScoreDtlTis'),
            meta: {
                title: '评分详情',
                auth: [],
                img: "pf"
            },
            props: route => {
                return route.query;
            }
        },
        {
            path: '/sc/score/ScIndex',
            name: 'scScore',
            component: () => import('@/views/serviceCenter/score/ScIndex'),
            meta: {
                title: '服务评分',
                auth: [],
                img: "pf"
            }
        },
        {
            path: '/sc/score/list',
            name: 'scScoreList',
            component: () => import('@/views/serviceCenter/score/list'),
            meta: {
                title: '服务评分',
                auth: [],
                img: "pf"
            },
            props: route => route.query
        },
        {
            path: '/sc/score/detail',
            name: 'scScoreDetail',
            hide: true,
            component: () => import('@/views/serviceCenter/score/detail'),
            meta: {
                title: '评分详情',
                auth: [],
                img: "pf"
            },
            props: route => route.query
        },
    ]
};
